import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CompanyStatusService {

  constructor(public httpClient: HttpClient) { }

  companyColor(status){
    if(status == ''){
      return 'text-dark';
    }else if(status == 'Active'){
      return 'text-success';
    }else if(status == 'Inactive' || status == 'WRIT'){
      return 'text-danger';
    }else if(status == 'Hold'){
      return 'text-warning';
    }else{
      return 'text-dark';
    }
  }

  getCompanyIftaStatus(companyId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/CompanyServices/IftaStatus/${companyId}`;
    return this.httpClient.get<any[]>(url);
  }

  getCompanyUcrStatus(companyId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/CompanyServices/UcrStatus/${companyId}`;
    return this.httpClient.get<any[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/company/company-status.service.ts